<template>
  <el-dialog :visible.sync="visible" :title="type==='add'?'新增分组':'修改分组名'" width="500px" :before-close="close">
    <div class="f--c">
      <div style="flex-shrink: 0">请输入分组名称：</div>
      <el-input size="medium" v-model="groupName" placeholder="请输入"></el-input>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="medium" @click="close">取 消</el-button>
      <el-button type="primary" size="medium" @click="confirm">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import API from '@/api';
export default {
  props: {
    manualForm: {
      type: Object,
      default: () => {}
    },
    manual: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      type: 'add',
      groupName: ''
    }
  },
  methods: {
    show(data) {
      this.type = data.type
      this.groupName = data.type === 'edit' ? this.manualForm.groupName : ''
      this.visible = true

    },

    confirm() {
      this.setAlbumModuleProduct()
      this.close()
    },

    close() {
      this.clear()
      this.visible = false
    },

    clear() {},

    // 设置商品
    setAlbumModuleProduct() {
      if (!this.groupName) {
        this.$message.warning('请输入组名')
        return
      }
      if (this.manual.findIndex(t => t.groupName === this.groupName) > -1) {
        this.$message.warning('组名重复，请重新输入')
        return
      }
      let param = {
        moduleId: this.manualForm.moduleId,
        moduleRuleId: this.manualForm.moduleRuleId,
        groupName: this.groupName,
        defaultSort: 4,
      }
      if (this.type === 'edit') param.groupId = this.manualForm.groupId,
      console.log(param)
      API.setAlbumModuleProduct(param).then(res => {
        if (res.data && res.data.groupId) {
          param.groupId = res.data.groupId
          this.$emit('setGroupSuccess', this.type, param)
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
